import BasePainterTool from './BasePainterTool';
import TOOL_NAMES from './constants/toolNames';

export default class InterpolationTool extends BasePainterTool {
  constructor(props = {}) {
    const defaultProps = { name: TOOL_NAMES.INTERPOLATION_TOOL };
    const initialProps = Object.assign(defaultProps, props);
    super(initialProps, 'interpolation');
  }
}
